/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AutenticadoRouteImport } from './routes/_autenticado'
import { Route as CrearExperienciaRouteImport } from './routes/crear-experiencia'
import { Route as ExperienciasRouteImport } from './routes/experiencias'
import { Route as LegalRouteImport } from './routes/legal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RestablecerContrasenaRouteImport } from './routes/restablecer-contrasena'
import { Route as RolesRouteImport } from './routes/roles'
import { Route as SaberMasRouteImport } from './routes/saber-mas'
import { Route as AutenticadoBienvenidaRouteImport } from './routes/_autenticado/bienvenida'
import { Route as AutenticadoCentroRouteImport } from './routes/_autenticado/centro'
import { Route as AutenticadoEnlacesRouteImport } from './routes/_autenticado/enlaces'
import { Route as AutenticadoMisExperienciasRouteImport } from './routes/_autenticado/mis-experiencias'
import { Route as LegalDocumentoRouteImport } from './routes/legal.$documento'
import { Route as UnirseIdRouteImport } from './routes/unirse.$id'
import { Route as AutenticadoExperienciaIdTablonRouteImport } from './routes/_autenticado/experiencia.$id.tablon'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutenticadoRoute = AutenticadoRouteImport.update({
  id: '/_autenticado',
  getParentRoute: () => rootRouteImport,
} as any)
const CrearExperienciaRoute = CrearExperienciaRouteImport.update({
  id: '/crear-experiencia',
  path: '/crear-experiencia',
  getParentRoute: () => rootRouteImport,
} as any)
const ExperienciasRoute = ExperienciasRouteImport.update({
  id: '/experiencias',
  path: '/experiencias',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalRoute = LegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RestablecerContrasenaRoute = RestablecerContrasenaRouteImport.update({
  id: '/restablecer-contrasena',
  path: '/restablecer-contrasena',
  getParentRoute: () => rootRouteImport,
} as any)
const RolesRoute = RolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const SaberMasRoute = SaberMasRouteImport.update({
  id: '/saber-mas',
  path: '/saber-mas',
  getParentRoute: () => rootRouteImport,
} as any)
const AutenticadoBienvenidaRoute = AutenticadoBienvenidaRouteImport.update({
  id: '/bienvenida',
  path: '/bienvenida',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoCentroRoute = AutenticadoCentroRouteImport.update({
  id: '/centro',
  path: '/centro',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoEnlacesRoute = AutenticadoEnlacesRouteImport.update({
  id: '/enlaces',
  path: '/enlaces',
  getParentRoute: () => AutenticadoRoute,
} as any)
const AutenticadoMisExperienciasRoute =
  AutenticadoMisExperienciasRouteImport.update({
    id: '/mis-experiencias',
    path: '/mis-experiencias',
    getParentRoute: () => AutenticadoRoute,
  } as any)
const LegalDocumentoRoute = LegalDocumentoRouteImport.update({
  id: '/$documento',
  path: '/$documento',
  getParentRoute: () => LegalRoute,
} as any)
const UnirseIdRoute = UnirseIdRouteImport.update({
  id: '/unirse/$id',
  path: '/unirse/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AutenticadoExperienciaIdTablonRoute =
  AutenticadoExperienciaIdTablonRouteImport.update({
    id: '/experiencia/$id/tablon',
    path: '/experiencia/$id/tablon',
    getParentRoute: () => AutenticadoRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/crear-experiencia': typeof CrearExperienciaRoute
  '/experiencias': typeof ExperienciasRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/restablecer-contrasena': typeof RestablecerContrasenaRoute
  '/roles': typeof RolesRoute
  '/saber-mas': typeof SaberMasRoute
  '/bienvenida': typeof AutenticadoBienvenidaRoute
  '/centro': typeof AutenticadoCentroRoute
  '/enlaces': typeof AutenticadoEnlacesRoute
  '/mis-experiencias': typeof AutenticadoMisExperienciasRoute
  '/legal/$documento': typeof LegalDocumentoRoute
  '/unirse/$id': typeof UnirseIdRoute
  '/experiencia/$id/tablon': typeof AutenticadoExperienciaIdTablonRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/crear-experiencia': typeof CrearExperienciaRoute
  '/experiencias': typeof ExperienciasRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/restablecer-contrasena': typeof RestablecerContrasenaRoute
  '/roles': typeof RolesRoute
  '/saber-mas': typeof SaberMasRoute
  '/bienvenida': typeof AutenticadoBienvenidaRoute
  '/centro': typeof AutenticadoCentroRoute
  '/enlaces': typeof AutenticadoEnlacesRoute
  '/mis-experiencias': typeof AutenticadoMisExperienciasRoute
  '/legal/$documento': typeof LegalDocumentoRoute
  '/unirse/$id': typeof UnirseIdRoute
  '/experiencia/$id/tablon': typeof AutenticadoExperienciaIdTablonRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_autenticado': typeof AutenticadoRouteWithChildren
  '/crear-experiencia': typeof CrearExperienciaRoute
  '/experiencias': typeof ExperienciasRoute
  '/legal': typeof LegalRouteWithChildren
  '/login': typeof LoginRoute
  '/restablecer-contrasena': typeof RestablecerContrasenaRoute
  '/roles': typeof RolesRoute
  '/saber-mas': typeof SaberMasRoute
  '/_autenticado/bienvenida': typeof AutenticadoBienvenidaRoute
  '/_autenticado/centro': typeof AutenticadoCentroRoute
  '/_autenticado/enlaces': typeof AutenticadoEnlacesRoute
  '/_autenticado/mis-experiencias': typeof AutenticadoMisExperienciasRoute
  '/legal/$documento': typeof LegalDocumentoRoute
  '/unirse/$id': typeof UnirseIdRoute
  '/_autenticado/experiencia/$id/tablon': typeof AutenticadoExperienciaIdTablonRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/crear-experiencia'
    | '/experiencias'
    | '/legal'
    | '/login'
    | '/restablecer-contrasena'
    | '/roles'
    | '/saber-mas'
    | '/bienvenida'
    | '/centro'
    | '/enlaces'
    | '/mis-experiencias'
    | '/legal/$documento'
    | '/unirse/$id'
    | '/experiencia/$id/tablon'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/crear-experiencia'
    | '/experiencias'
    | '/legal'
    | '/login'
    | '/restablecer-contrasena'
    | '/roles'
    | '/saber-mas'
    | '/bienvenida'
    | '/centro'
    | '/enlaces'
    | '/mis-experiencias'
    | '/legal/$documento'
    | '/unirse/$id'
    | '/experiencia/$id/tablon'
  id:
    | '__root__'
    | '/'
    | '/_autenticado'
    | '/crear-experiencia'
    | '/experiencias'
    | '/legal'
    | '/login'
    | '/restablecer-contrasena'
    | '/roles'
    | '/saber-mas'
    | '/_autenticado/bienvenida'
    | '/_autenticado/centro'
    | '/_autenticado/enlaces'
    | '/_autenticado/mis-experiencias'
    | '/legal/$documento'
    | '/unirse/$id'
    | '/_autenticado/experiencia/$id/tablon'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AutenticadoRoute: typeof AutenticadoRouteWithChildren
  CrearExperienciaRoute: typeof CrearExperienciaRoute
  ExperienciasRoute: typeof ExperienciasRoute
  LegalRoute: typeof LegalRouteWithChildren
  LoginRoute: typeof LoginRoute
  RestablecerContrasenaRoute: typeof RestablecerContrasenaRoute
  RolesRoute: typeof RolesRoute
  SaberMasRoute: typeof SaberMasRoute
  UnirseIdRoute: typeof UnirseIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_autenticado': {
      id: '/_autenticado'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AutenticadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crear-experiencia': {
      id: '/crear-experiencia'
      path: '/crear-experiencia'
      fullPath: '/crear-experiencia'
      preLoaderRoute: typeof CrearExperienciaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/experiencias': {
      id: '/experiencias'
      path: '/experiencias'
      fullPath: '/experiencias'
      preLoaderRoute: typeof ExperienciasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal': {
      id: '/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/restablecer-contrasena': {
      id: '/restablecer-contrasena'
      path: '/restablecer-contrasena'
      fullPath: '/restablecer-contrasena'
      preLoaderRoute: typeof RestablecerContrasenaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roles': {
      id: '/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof RolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/saber-mas': {
      id: '/saber-mas'
      path: '/saber-mas'
      fullPath: '/saber-mas'
      preLoaderRoute: typeof SaberMasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_autenticado/bienvenida': {
      id: '/_autenticado/bienvenida'
      path: '/bienvenida'
      fullPath: '/bienvenida'
      preLoaderRoute: typeof AutenticadoBienvenidaRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/centro': {
      id: '/_autenticado/centro'
      path: '/centro'
      fullPath: '/centro'
      preLoaderRoute: typeof AutenticadoCentroRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/enlaces': {
      id: '/_autenticado/enlaces'
      path: '/enlaces'
      fullPath: '/enlaces'
      preLoaderRoute: typeof AutenticadoEnlacesRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/_autenticado/mis-experiencias': {
      id: '/_autenticado/mis-experiencias'
      path: '/mis-experiencias'
      fullPath: '/mis-experiencias'
      preLoaderRoute: typeof AutenticadoMisExperienciasRouteImport
      parentRoute: typeof AutenticadoRoute
    }
    '/legal/$documento': {
      id: '/legal/$documento'
      path: '/$documento'
      fullPath: '/legal/$documento'
      preLoaderRoute: typeof LegalDocumentoRouteImport
      parentRoute: typeof LegalRoute
    }
    '/unirse/$id': {
      id: '/unirse/$id'
      path: '/unirse/$id'
      fullPath: '/unirse/$id'
      preLoaderRoute: typeof UnirseIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_autenticado/experiencia/$id/tablon': {
      id: '/_autenticado/experiencia/$id/tablon'
      path: '/experiencia/$id/tablon'
      fullPath: '/experiencia/$id/tablon'
      preLoaderRoute: typeof AutenticadoExperienciaIdTablonRouteImport
      parentRoute: typeof AutenticadoRoute
    }
  }
}

interface AutenticadoRouteChildren {
  AutenticadoBienvenidaRoute: typeof AutenticadoBienvenidaRoute
  AutenticadoCentroRoute: typeof AutenticadoCentroRoute
  AutenticadoEnlacesRoute: typeof AutenticadoEnlacesRoute
  AutenticadoMisExperienciasRoute: typeof AutenticadoMisExperienciasRoute
  AutenticadoExperienciaIdTablonRoute: typeof AutenticadoExperienciaIdTablonRoute
}

const AutenticadoRouteChildren: AutenticadoRouteChildren = {
  AutenticadoBienvenidaRoute: AutenticadoBienvenidaRoute,
  AutenticadoCentroRoute: AutenticadoCentroRoute,
  AutenticadoEnlacesRoute: AutenticadoEnlacesRoute,
  AutenticadoMisExperienciasRoute: AutenticadoMisExperienciasRoute,
  AutenticadoExperienciaIdTablonRoute: AutenticadoExperienciaIdTablonRoute,
}

const AutenticadoRouteWithChildren = AutenticadoRoute._addFileChildren(
  AutenticadoRouteChildren,
)

interface LegalRouteChildren {
  LegalDocumentoRoute: typeof LegalDocumentoRoute
}

const LegalRouteChildren: LegalRouteChildren = {
  LegalDocumentoRoute: LegalDocumentoRoute,
}

const LegalRouteWithChildren = LegalRoute._addFileChildren(LegalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AutenticadoRoute: AutenticadoRouteWithChildren,
  CrearExperienciaRoute: CrearExperienciaRoute,
  ExperienciasRoute: ExperienciasRoute,
  LegalRoute: LegalRouteWithChildren,
  LoginRoute: LoginRoute,
  RestablecerContrasenaRoute: RestablecerContrasenaRoute,
  RolesRoute: RolesRoute,
  SaberMasRoute: SaberMasRoute,
  UnirseIdRoute: UnirseIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
